<template>
  <div>
    <vs-tooltip text="Import XLSX" position="top">
      <vs-button
        color="#333f50"
        radius
        icon="cloud_upload"
        class="text-none mr-2"
        round
        type="flat"
        depressed
        v-b-modal.ImportExcel
      >
      </vs-button>
      <input
        ref="uploader"
        class="d-none"
        type="file"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        @change="onFileChanged"
      />
    </vs-tooltip>
    <b-modal id="ImportExcel" centered hide-footer size="xl">
      <template #modal-title>
        <h3>Import a list of Parts into Factory</h3>
      </template>
      <br />
      <template>
        <div class="ml-2">
          <vs-col>
            <b>To import Parts please follow the following steps: </b>
            <br />
            <br />
            <p @click="myFunction()">
              1) Download the
              <a href="path_to_file" download="proposed_file_name"
                >Sample Import File</a
              >
            </p>

            <p>
              2) <b style="color: red">Do not change Row 1.</b> Limble needs
              these headers to stay the same so it knows how to import the data.
            </p>
            <p>
              3) Start adding rows. Each row starting at row 2 will create a new
              part so don't forget to delete the sample rows provided.<b
                >Limit of 5000 new parts at a time.</b
              >
            </p>
            <ul class="ml-5">
              <li>
                <p>Part Name - <b>required</b></p>
              </li>
              <li>
                <p>Part Number - optional</p>
              </li>
              <li>
                <p>Part Price - optional</p>
              </li>
              <li>
                <p>Quantity - optional</p>
              </li>
              <li>
                <p>Part Location - optional</p>
              </li>
              <li>
                <p>Category - optional</p>
              </li>
              <li>
                <p>Stale Threshold - optional</p>
              </li>
              <li>
                <p>Minimum Part Qty Threshold - optional</p>
              </li>
              <li>
                <p>Max Part Qty Threshold - optional</p>
              </li>
              <li>
                <p>Threshold Tasks assigned to - optional</p>
              </li>
              <li>
                <p>Manually Associate Assets - optional</p>
              </li>
              <li>
                <p>Manually Associate Vendors - optional</p>
              </li>
            </ul>
            <p>
              4) Start adding rows. Each row (starting at row 2) will create a
              new Part so don't forget to delete the sample rows provided.
            </p>
            <p>5) Save and upload the file.</p>
            <ul>
              <vs-checkbox
                color="success"
                v-model="checkBox2"
                style="right: 205px"
              >
                Only associate parts to assets and vendors at this
                location</vs-checkbox
              >
            </ul>
            <br />
            <vs-button
              color="#32C040"
              style="border-radius: 20px"
              class="text-none mr-2"
              round
              depressed
              :loading="isSelecting"
              @click="onButtonClick"
              >Upload CSV
            </vs-button>
          </vs-col>
          <template>
            <vs-row class="ml-3 mt-5" vs-w="12">
              <vs-spacer />
              <b-button
                id="btncancel"
                variant="light"
                style="border-radius: 20px; width: 10%"
                @click="$bvModal.hide('ImportExcel')"
              >
                Exit
              </b-button>
              <vs-button
                class="ml-2 mr-4"
                type="filled"
                style="border-radius: 20px"
                color="success"
                >Confirm</vs-button
              >
            </vs-row>
          </template>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import XLSX from "xlsx";
import input from "../../vuesax/input/input.vue";
export default {
  data: () => ({
    selectedFile: null,
    isSelecting: false,
  }),
  components: { input },
  computed: {
    buttonText() {
      return this.selectedFile
        ? this.selectedFile.name
        : this.defaultButtonText;
    },
  },
  methods: {
    onButtonClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      this.selectedFile = e.target.files[0];
    },
    myFunction() {
      console.log("aa");
    },
  },
};
</script>

<style>
</style>